import { getCookie as getControlledCookie } from '@atlassian/browser-storage-controls';

declare global {
	// global variables will only show up on GlobalThis with a var declaration
	// eslint-disable-next-line vars-on-top
	var __GET_COOKIE__: (name?: string) =>
		| string
		| {
				[key: string]: string;
		  }
		| undefined;
}

export function getCookie(): { [key: string]: string };
export function getCookie(key: string, ssr?: boolean): string | undefined; // This is used in index.server.tsx
export function getCookie(key?: string) {
	return key ? getControlledCookie(key) : getControlledCookie();
}
